import type { FC } from 'react';
import React from 'react';

import type { TDropDown } from './models';

export const DropDown: FC<TDropDown> = ({ BannerLink, DataLayer, dropDownData, styles }) => {
    if (!dropDownData) return null;

    return (
        <>
            <div className={styles.triangle} />
            <div className={styles.triangleAfter} />
            <div className={styles.dropDownHitbox}>
                <div className={styles.dropDown}>
                    {dropDownData.map((column, columnIndex) => (
                        <div
                            // eslint-disable-next-line react/no-array-index-key
                            key={columnIndex}
                            className={styles.dropDownColumn}
                        >
                            {column.map(({ analytics, link, title, type }, rowIndex) => {
                                let className = styles.dropDownText;

                                if (type === 'header') {
                                    className = styles.dropDownHeader;
                                }

                                return (
                                    <DataLayer
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={rowIndex}
                                        data={analytics}
                                    >
                                        <BannerLink link={link} title={title}>
                                            <div className={className}>{title}</div>
                                        </BannerLink>
                                    </DataLayer>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
